import openreplayService from './openreplayService';

export default openreplayService;
